var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelescope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 196,
    viewBox: "0 0 164 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telescope"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tripod"
  }, /*#__PURE__*/React.createElement("g", {
    id: "legs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M94.1154 86.375V192.461C94.1154 193.963 92.8976 195.181 91.3954 195.181H88.4538C86.9516 195.181 85.7338 193.963 85.7338 192.461V89.2919L94.1154 86.375Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path 2",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M94.1154 86.375V192.461C94.1154 193.963 92.8976 195.181 91.3954 195.181H88.4538C86.9516 195.181 85.7338 193.963 85.7338 192.461V89.2919L94.1154 86.375Z",
    fill: "#FFBA68",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M91.4446 181.414V195.168",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M91.4446 177.182V179.299",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "leg-2",
    d: "M88.3431 121.249L49.98 192.166C49.0739 193.843 46.9804 194.468 45.3031 193.563L44.0046 192.855C43.1996 192.422 42.6004 191.685 42.3395 190.809C42.0785 189.932 42.1772 188.988 42.6138 188.185L80.5769 118C82.7888 119.825 85.4907 120.955 88.3431 121.249Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "leg-3",
    d: "M135.962 192.769L134.343 193.649C132.754 194.505 130.772 193.913 129.912 192.326L91.4631 121.249C94.3067 120.95 96.9993 119.82 99.2046 118L137.266 188.363C138.112 189.941 137.53 191.906 135.962 192.769Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tripod_\xD1\x81ircle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "black_circle",
    d: "M104.497 106.732C104.498 114.197 98.8672 120.46 91.4446 121.249C90.4217 121.354 89.3906 121.354 88.3677 121.249C80.5536 120.411 74.8058 113.537 75.3646 105.698C75.9235 97.8588 82.5883 91.8693 90.4423 92.148C98.2963 92.4267 104.52 98.8736 104.522 106.732H104.497Z",
    fill: "#1D1E5F",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "white_circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 89.8938,
    cy: 106.732,
    r: 7.90154,
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M89.5492 101.711C91.7411 101.712 93.7204 103.023 94.5769 105.04",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "telescope-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "telescope-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M83.4815 30.2227L79.1062 33.2196C77.2832 34.4706 76.6676 36.8777 77.6662 38.8503L100.583 84.155C101.58 86.1296 103.886 87.059 105.974 86.3273L110.977 84.5734L83.4815 30.2227Z",
    fill: "#47DDDF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.497 15.8465L83.4815 30.2219L110.977 84.5419L138.54 74.8681L157.5 68.2158L159.346 67.6004C159.937 67.3985 160.412 66.9508 160.648 66.3727C160.883 65.7946 160.858 65.1427 160.577 64.585L128.928 2.105C128.645 1.54986 128.137 1.14353 127.534 0.990271C126.93 0.837011 126.29 0.951732 125.777 1.305L123.395 2.92346L110.977 11.4281",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.497 15.8465L83.4815 30.2219L110.977 84.5419L138.54 74.8681L157.5 68.2158L159.346 67.6004C159.937 67.3985 160.412 66.9508 160.648 66.3727C160.883 65.7946 160.858 65.1427 160.577 64.585L128.928 2.105C128.645 1.54986 128.137 1.14353 127.534 0.990271C126.93 0.837011 126.29 0.951732 125.777 1.305L123.395 2.92346L110.977 11.4281",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M39.4569 65.5996L34.7123 68.8611C33.6914 69.5609 33.3489 70.9099 33.9123 72.0119L48.1215 100.086C48.6724 101.194 49.9609 101.721 51.1308 101.317L56.5769 99.4088L39.4569 65.5996Z",
    fill: "#FF81AF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M100.583 84.1229L94.0846 86.3813L85.7031 89.2921L56.5708 99.409L39.4569 65.5998L77.8323 39.1875L100.583 84.1229Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M34.3246 72.832L47.7031 99.2936L17.4815 110.863C17.4815 110.801 17.4261 110.734 17.3954 110.672L7.27229 90.6782C7.21426 90.5579 7.14633 90.4426 7.06921 90.3336L34.3246 72.832Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M7.2723 90.6769L17.3954 110.671C17.4261 110.732 17.4569 110.8 17.4815 110.862C17.8037 111.597 17.841 112.426 17.5861 113.188C17.172 114.454 16.0353 115.346 14.7066 115.447C13.378 115.548 12.1194 114.838 11.5185 113.649L1.39538 93.6492C0.472637 92.0824 0.994742 90.0642 2.56153 89.1415C4.12832 88.2188 6.14648 88.7409 7.06922 90.3077C7.14756 90.4246 7.21551 90.5481 7.2723 90.6769Z",
    fill: "#47DDDF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens"
  }, /*#__PURE__*/React.createElement("path", {
    id: "lens-2",
    d: "M129.672 3.57617L160.06 63.6069C163.931 54.2469 162.878 40.6654 156.368 27.7731C149.857 14.8808 139.512 6.00079 129.672 3.57617Z",
    fill: "#87D4FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M147.143 21.1817C146.288 20.0802 145.408 19.0279 144.497 18.0371",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M153.666 32.1487C153.303 31.3364 152.922 30.5303 152.509 29.6872C151.318 27.3345 149.957 25.072 148.435 22.918",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "line-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M137.721 67.8642L143.438 65.5996",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M119.242 75.1865L135.045 68.9219",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M102.232 82.6641C102.938 84.0612 104.572 84.7172 106.048 84.1964",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    d: "M80.7923 34.3379C79.5012 35.2237 79.0646 36.9281 79.7708 38.3256",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stroke_lines"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lines-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M60.9338 67.5449L74.3185 74.0618",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    d: "M66.3062 65.7305L74.0661 69.5028",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M59.4015 71.2383L70.9277 76.8444",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lines-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    d: "M69.0938 62.4629L65.7461 78.9244",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    d: "M64.3061 66.0137L62.4292 75.2506",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    d: "M72.6815 64.8516L70.5707 75.2146",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelescope);
export default __webpack_public_path__ + "static/media/telescope.ea4091b7f6bcd381c45cced9be521110.svg";
export { ForwardRef as ReactComponent };